import {
    ProgressBarSingleContentContainer,
    ProgressBarSingleTextContainer,
    SearchInput,
    Text,
} from "pro-features/components/filtersPanel/src/filterPanelStyled";
import { ProgressBar } from "app/components/React/ProgressBar/ProgressBar";
import { percentageFilter } from "app/filters/ngFilters";
import { DefaultFetchService } from "app/services/fetchService";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import type { IChosenItem } from "../../../../app/@types/chosenItems";
import { allTrackers } from "app/services/track/track";

export const getPhraseFilterData = (phraseFilterDataEndpoint: string) => async (filters: FixmeType) => {
    const fetchService = DefaultFetchService.getInstance();
    try {
        const data = await fetchService.get<any>(phraseFilterDataEndpoint, filters);
        const phraseFilterData = data.map((dataItem: FixmeType) => {
            const { SearchTerm: searchTerm, Share: share, SiteOrigins: siteOrigins } = dataItem;
            return { searchTerm, share, siteOrigins };
        });
        return phraseFilterData;
    } catch (e) {
        return [];
    }
};

export interface IPhraseFilterProps {
    filterData: IFilterData[];
    onClickCallback: (filterData: IFilterData) => void;
    chosenItems: IChosenItem[];
    searchPlaceholder?: string;
    trafficShareProgressBarTooltipHeader?: string;
    tableHeadersCompare?: string[];
    tableHeadersSingle?: string[];
}

interface ISiteOrigins {
    [key: string]: string;
}

interface IFilterData {
    searchTerm: string;
    share: string;
    siteOrigins: ISiteOrigins;
}

export const filterBySearchValue =
    (query: string) =>
    ({ searchTerm }: FixmeType) =>
        searchTerm.includes(query);

export const shareFilter = (share: FixmeType) => {
    const PERCENTAGE_FILTER_FRACTION_LENGTH = 2;
    const DEFAULT_PERCENTAGE_SIGN = "%";
    const shareValuePercents = percentageFilter()(share, PERCENTAGE_FILTER_FRACTION_LENGTH) + DEFAULT_PERCENTAGE_SIGN;
    return shareValuePercents;
};

export const ProgressBarSingle = ({ share, hideData = false }: FixmeType) => {
    const NA = "NA";
    const shareValuePercents = shareFilter(share);
    const progressBarWidth = share ? share * 100 : Number();
    return (
        !hideData && (
            <FlexRow>
                <ProgressBarSingleTextContainer>
                    <Text fontSize={14}>{shareValuePercents}</Text>
                </ProgressBarSingleTextContainer>
                <ProgressBarSingleContentContainer>
                    {shareValuePercents !== NA ? <ProgressBar width={progressBarWidth} /> : null}
                </ProgressBarSingleContentContainer>
            </FlexRow>
        )
    );
};

export const createTableHeader = (header: string) => {
    const HEADER_TEXT_OPACITY = 0.7;
    return <Text opacity={HEADER_TEXT_OPACITY}>{header}</Text>;
};

export const SearchInputWrapper = ({ searchPlaceholder, onChange }: FixmeType) => {
    const SEARCH_INPUT_DEFAULT_ICON = "search";
    const onFocus = () => {
        allTrackers.dispatchTrackEvent("Drop Down", "open", "Phrase");
    };
    return (
        <SearchInput
            onFocus={onFocus}
            inputFocusParameters={{ preventScroll: true }}
            isFocused={true}
            hideBorder={true}
            iconName={SEARCH_INPUT_DEFAULT_ICON}
            placeholder={searchPlaceholder}
            onChange={onChange}
        />
    );
};
